import Headers from 'fetch-headers/headers-es5.min.js'
import {DOMEN} from '../../../common/constants'
declare const ENV_IS_DEV: boolean

export const COMPONENT_SIZE = 'large'

export const HEADER_STEPS = [
    {
        name: 'Параметры груза',
    },
    {
        name: 'Параметры перевозки',
    },
    {
        name: 'Расчет и договор',
    },
]
export const HEADER_STEPS_INSURER = [
    {
        name: 'Параметры груза',
    },
    {
        name: 'Параметры перевозки',
    },
    {
        name: 'Страхователь',
    },
]

export const POST = 'POST'
export const HEADERS = new Headers([['Content-Type', 'application/json']])

export const URL_GET_CARGO_TYPES = `${DOMEN}/cargo/v1/types`
export const URL_GET_PROGRAM_INFO = `${DOMEN}/cargo/v1/programs`
export const URL_GET_COST = `${DOMEN}/cargo/v1/calculations`
export const URL_REQUEST_CALLBACK = `${DOMEN}/cargo/v1/calculations/`

export const URL_RULES =
    'https://euro-ins.ru/wp-content/uploads/pravila/9-1-Pravila_strah_Gruzov.pdf'
export const URL_RULES_COMPLEX =
    'https://euro-ins.ru/wp-content/uploads/pravila/9-2-Pravila_strah_Gruzov_kompl.pdf'
